import { BannerTypes, PredefinedBanner } from 'components/page-flag/types'

export const PredefinedBanners: Record<BannerTypes | string, PredefinedBanner> = {
  [BannerTypes.MIDDLE_EAST_ENERGY_CRISIS]: {
    type: 'light',
    titleNsAndKey: 'common:middleEastCrisisBanner.title',
    descriptionNsAndKey: 'common:middleEastCrisisBanner.description',
    singleLine: true,
    noOnClick: true,
    size: 'small'
  },

  [BannerTypes.SCHEDULED_DOWNTIME]: {
    type: 'attention',
    titleNsAndKey: 'common:scheduledDowntime.title',
    descriptionNsAndKey: 'common:scheduledDowntime.description'
  },

  [BannerTypes.BRUSSELS_BEER_PROJECT]: {
    type: 'attention',
    titleNsAndKey: 'brusselsBeerProject:banner.title',
    descriptionNsAndKey: 'brusselsBeerProject:banner.small'
  },

  [BannerTypes.VIA_VIA]: {
    type: 'attention',
    titleNsAndKey: 'home:viralloopsnotification'
  },

  [BannerTypes.SIMULATION_DOWN]: {
    type: 'attention',
    titleNsAndKey: 'common:simulationDown.title',
    descriptionNsAndKey: 'common:simulationDown.apologies'
  }
}
